<template>
  <el-drawer title=""
             :visible.sync="advertisingBannerVisible"
             direction="ttb"
             size="50%"
             @close="advertisingBannerVisibleClose">

    <a class="advertisement"
       :href="advertiDetail.blogroll"
       target="_blank"
       v-if="!advertiDetail.isStop">
      <img :src="advertiDetail.pcImgUrl"
           alt="">
    </a>

  </el-drawer>
</template>
<script>
export default {
  props: {
    visible: Boolean,
  },
  data () {
    return {
      advertiDetail: {},
      advertisingBannerVisible: false,
    };
  },
  methods: {

    AdvertisingManageDetail () {
      let sendData = {
        id: 'f4ee7e10-1d07-4787-bf4f-2c80a3eca56a',
      }
      this.$api.manage.AdvertisingManageDetail(sendData).then((res) => {
        if (res.code === 0) {
          this.advertiDetail = res.data
          console.log(res.data);
        }
      });
    },
    advertisingBannerVisibleClose () {
      this.$emit("close");
    },
  },
  watch: {
    visible (val) {
      this.AdvertisingManageDetail()
      this.advertisingBannerVisible = val;
    },
  },
};
</script>
<style lang="less" scoped>
.advertisement {
  width: 100%;
  p {
    font-size: 16px;
    line-height: 38px;
  }
}
</style>